import React from "react";

const SvgAlertCircle = props => <svg viewBox="0 0 20 20" {...props}><g fill="none" fillRule="evenodd"><path fill="#9AA7B1" d="M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8" /><path fill="#603276" d="M10 11a1 1 0 0 1-1-1V6a1 1 0 1 1 2 0v4a1 1 0 0 1-1 1zm0 1.9a1.1 1.1 0 1 1 0 2.2 1.1 1.1 0 0 1 0-2.2z" /></g></svg>;

export default SvgAlertCircle;